export default class PlayPauseMedia {
  constructor(media, button) {
    this.media = media;
    this.button = button;
    this.hasControls = this.media.hasAttribute('controls');
    this.setPauseState();
    this.listen();
  }

  play() {
    this.setPlayState();
    this.media.play();
  }

  pause() {
    this.setPauseState();
    this.media.pause();
  }

  setPlayState() {
    this.button.classList.add('playing');

    if (this.hasControls) {
      this.media.setAttribute('controls', 'controls');
    }
  }

  setPauseState() {
    this.button.classList.remove('playing');

    if (this.hasControls) {
      this.media.removeAttribute('controls');
    }
  }

  handleClick() {
    return this.media.paused ? this.play() : this.pause();
  }

  listen() {
    this.button.addEventListener('click', this.handleClick.bind(this));
    this.media.addEventListener('play', this.setPlayState.bind(this));
    this.media.addEventListener('pause', this.setPauseState.bind(this));
  }
}
